import type { ReadonlyDeep } from "type-fest";

type SolvariEnv = ReadonlyDeep<{
  auth: {
    attributionUserId: string | null;
    jwtToken: string | null;
  };
  config: {
    envBE: "acceptance" | "develop" | "local" | "production" | "testing";
    envType: "local" | "production" | "staging" | "testing";
    lang: "fr" | "nl";
    localeCode: "be-FR" | "be-NL" | "dk-DA" | "fr-FR" | "nl-NL" | "se-SV";
    themeId: number | string | null;
    translationsTimestamp: number | null;
    urlPrefix: "" | "fr" | "nl";
  };
  integrations: {
    algolia: {
      applicationId: string;
      env: "dev" | "prd" | "stg";
      publicSearchApiKey: string;
    };
    pusher: {
      appId: string;
      cluster: string;
      key: string;
    };
  };
  network: {
    admin: string;
    api: string;
    argus: string;
    client: {
      base: string;
      baseWithPrefix: string;
    };
    pro: {
      base: string;
      baseWithPrefix: string;
    };
    static: string;
  };
}>;

declare global {
  var solvariEnv: SolvariEnv | undefined;
}

function getEnv(): SolvariEnv {
  if (!globalThis.solvariEnv) {
    throw new Error("Could not find solvariEnv variables on globalThis.");
  }
  return globalThis.solvariEnv;
}

export type { SolvariEnv };
export { getEnv };
